export enum SyncPlayInType {
  SET_PLAY_IN_INITIAL_STATE_ERROR = 'SET_PLAY_IN_INITIAL_STATE_ERROR',
  SET_PLAY_IN_INITIAL_STATE_SUCCESS = 'SET_PLAY_IN_INITIAL_STATE_SUCCESS'
}
